// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1EZKh","title":"FrontImage_title__2Mfnf"};